import { SelectPickerOptionProps } from '@components/SelectPicker/types';

import { SelectedOptionType } from './types';

export const transformSelectedOptions = (
    options: SelectPickerOptionProps[] | SelectPickerOptionProps,
    isSingleSelect = false,
): Array<SelectedOptionType> | [] => {
    const transformedOptions: Array<SelectedOptionType> = [];

    if (isSingleSelect && !Array.isArray(options) && Object.keys(options).length) {
        transformedOptions.push({
            label: options?.label,
            value: options?.value,
            id: `${options?.value}_${options?.label}`,
        });
        return transformedOptions;
    }

    if (Array.isArray(options) && options?.length) {
        options?.forEach((option, index) => {
            transformedOptions.push({
                label: option?.label,
                value: option?.value,
                id: `${option?.value}_${index}`,
            });
        });
        return transformedOptions;
    }
    return [];
};

export const sortedOptions = (
    options: SelectPickerOptionProps[],
    selectedOptions: SelectedOptionType[],
): SelectPickerOptionProps[] | null => {
    if (options?.length && selectedOptions?.length) {
        const selectedOptionsMap = new Map(selectedOptions.map((obj) => [obj?.label, obj?.value]));
        const finalSortedOptions: SelectPickerOptionProps[] = [];

        /** First push the selected options to the finalSortedOptions array */
        options?.forEach((option) => {
            if (selectedOptionsMap.has(option?.label)) {
                finalSortedOptions.push(option);
            }
        });

        /** Now pushing the non-selected options to the finalSortedOptions array */
        options?.forEach((option) => {
            if (!selectedOptionsMap.has(option?.label)) {
                finalSortedOptions.push(option);
            }
        });
        return finalSortedOptions;
    }
    return null;
};
